var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBox)?_c('div',{staticClass:"company-box"},[_c('a',{staticClass:"weui-btn_cell weui-btn_cell-default",attrs:{"href":"javascript:;"},on:{"click":_vm.showCompanyList}},[_vm._v(_vm._s(_vm.company.name)),_c('span',{staticClass:"iconfont icon-more"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }